import { createFileRoute, redirect } from '@tanstack/react-router'
import { OrderFormScreen } from '@/features/sales-orders/order-form-screen'
import { hasGrant } from '@/lib/me'

/**
 * Route shell for editing a DRAFT sales order (plan screen 3, edit mode).
 *
 * The API refuses an update on anything but a draft
 * (`order-form-screen.tsx`'s own comment), so this guard only keeps a user
 * without `sales_order.edit` out of a screen they cannot use; the route
 * itself is reachable for a non-draft order and the form renders its loaded
 * values without a save that would succeed.
 */
export const Route = createFileRoute('/_authenticated/sales/orders/$orderId/edit')({
  beforeLoad: ({ context, params }) => {
    if (!hasGrant(context.queryClient, 'sales_order.edit')) {
      throw redirect({ to: '/sales/orders/$orderId', params: { orderId: params.orderId } })
    }
  },
  component: SalesOrderEditRoute,
})

function SalesOrderEditRoute() {
  const { orderId } = Route.useParams()

  return <OrderFormScreen orderId={orderId} />
}
